import React from 'react';

import { useIsAllowed } from '@gogame/permissions';

import { Action, Actions, ActionBar } from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useChildComponent } from '@gogame/hooks-ts';
import { SearchField, useScreenTitle } from '@gogame/screens';
import {
  PromoCodeSetFormCreate,
  PublicPromoCodeFormCreate,
} from 'scenes/PromoCodes/components/PromoCodesForm';

export const MANAGE_PROMO_CODES = 31;

export default () => {
  const [childComponent, openChildComponent] = useChildComponent();
  const [screenTitle] = useScreenTitle();

  const canManagePromoCodes = useIsAllowed()(MANAGE_PROMO_CODES);

  const handleOpenSetPromocodeForm = () => {
    openChildComponent(PromoCodeSetFormCreate);
  };

  const handleOpenPublicPromocodeForm = () => {
    openChildComponent(PublicPromoCodeFormCreate);
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={
          <SearchField
            tooltip={'Search by name, id, code'}
            applyFilters={true}
          />
        }
        primaryActions={
          canManagePromoCodes ? (
            <Actions>
              <Action
                border={true}
                button={true}
                add={true}
                iconContent={true}
                tooltip={'Add Promo Code'}
                variant={'outlined'}
              >
                <Action
                  label={'Public code'}
                  onClick={handleOpenPublicPromocodeForm}
                />
                <Action
                  label={'Set of personal codes'}
                  onClick={handleOpenSetPromocodeForm}
                />
              </Action>
            </Actions>
          ) : null
        }
        secondaryActions={
          <Actions>
            <Action component={FullScreenToggler} />
          </Actions>
        }
      />
      {childComponent}
    </>
  );
};
